<template>
  <div></div>
</template>

<script>
export default {
  name: 'category-vue'
}
</script>

<style lang="less" scoped>
</style>
